import { Container, Line, ListItem, renderPrompt, Section, UnorderedList } from '~/lib/prompts/prompt-components';
import { removeWorkDir } from '~/utils/workDir';

export function createImportFiles(
  files: Array<{ path: string; content: string; lastModified?: number }>,
  hiddenFiles: string[],
) {
  // sort files based on their last modified timestamp and path to optimize for cache reads
  files.sort((fileA, fileB) => {
    if (fileA.lastModified === undefined && fileB.lastModified === undefined) {
      return fileA.path.localeCompare(fileB.path);
    }

    if (fileA.lastModified === undefined) {
      return 1;
    }

    if (fileB.lastModified === undefined) {
      return -1;
    }

    return fileA.lastModified - fileB.lastModified;
  });

  const projectFiles = (
    <Section name="project_files">
      <Line>
        The following is a list of all project files and their complete contents that are currently visible and
        accessible to you.
      </Line>

      <Container spaceBetween={2}>
        {files.map(({ path, content }) => {
          return (
            <Container key={path}>
              {`${path}:`}
              {'```'}
              {content}
              {'```'}
            </Container>
          );
        })}
      </Container>

      {hiddenFiles && hiddenFiles.length > 0 && serializeHiddenFiles(hiddenFiles)}
    </Section>
  );

  return renderPrompt(projectFiles);
}

function serializeHiddenFiles(hiddenFiles: string[]) {
  return renderPrompt(
    <Container spaceBetween={2}>
      <Line>
        Here is a list of files that exist on the file system but are not being shown to you. You cannot read these
        files.
      </Line>

      <UnorderedList>
        {hiddenFiles.map((hiddenFile, index) => (
          <ListItem key={index}>{removeWorkDir(hiddenFile)}</ListItem>
        ))}
      </UnorderedList>
    </Container>,
  );
}
